const normalizeEpochMillis = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (typeof value === 'bigint') {
    return Number(value);
  }

  if (typeof value === 'number') {
    return Number.isFinite(value) ? value : null;
  }

  if (typeof value === 'string') {
    const trimmed = value.trim();
    if (trimmed.length === 0) {
      return null;
    }

    const parsedValue = Number(trimmed);
    return Number.isFinite(parsedValue) ? parsedValue : null;
  }

  return null;
};

const RFQ_TIME_ZONE = 'Europe/London';

const UTC_TIMESTAMP_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: 'UTC',
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

const TIME_ZONE_PARTS_FORMATTER = new Intl.DateTimeFormat('en-GB', {
  timeZone: RFQ_TIME_ZONE,
  year: 'numeric',
  month: '2-digit',
  day: '2-digit',
  hour: '2-digit',
  minute: '2-digit',
  second: '2-digit',
  hour12: false,
});

const getTimeZoneOffsetMillis = (timestamp, timeZoneFormatter = TIME_ZONE_PARTS_FORMATTER) => {
  const date = new Date(timestamp);
  const parts = Object.fromEntries(
    timeZoneFormatter
      .formatToParts(date)
      .filter(({ type }) => type !== 'literal')
      .map(({ type, value }) => [type, Number(value)])
  );

  const zonedInstant = Date.UTC(
    parts.year,
    parts.month - 1,
    parts.day,
    parts.hour,
    parts.minute,
    parts.second,
    0
  );

  return zonedInstant - Math.floor(timestamp / 1000) * 1000;
};

const parseTransactTimeToEpochMillis = (transactTime) => {
  if (typeof transactTime !== 'string' || transactTime.length === 0) {
    return 0;
  }

  const match = transactTime.match(
    /^(\d{4})(\d{2})(\d{2})-(\d{2}):(\d{2}):(\d{2})(?:\.(\d{1,3}))?$/
  );

  if (!match) {
    return 0;
  }

  const [, year, month, day, hour, minute, second, millis = '0'] = match;
  const utcGuess = Date.UTC(
    Number(year),
    Number(month) - 1,
    Number(day),
    Number(hour),
    Number(minute),
    Number(second),
    Number(millis.padEnd(3, '0'))
  );

  // `transactTime` is emitted as Europe/London wall-clock time.
  const corrected = utcGuess - getTimeZoneOffsetMillis(utcGuess);
  const finalOffset = getTimeZoneOffsetMillis(corrected);
  return utcGuess - finalOffset;
};

const formatEpochMillis = (value) => {
  const millis = normalizeEpochMillis(value);
  if (millis === null) {
    return null;
  }

  return `${UTC_TIMESTAMP_FORMATTER.format(new Date(millis))} UTC`;
};

export { formatEpochMillis, normalizeEpochMillis, parseTransactTimeToEpochMillis };
